import React from 'react';
import './error.scss';
import SwellLogo from 'components/logo';

export default class Error404 extends React.Component {
  render() {
    return (
      <div className="error-container">
        {this.props.router && <SwellLogo />}
        <div className="error-wrapper">
          <div className="error-message">
            <h1>Sorry, this page could not be found.</h1>
            <p>You may have followed an incorrect link or mistyped the URL.</p>
          </div>
        </div>
      </div>
    );
  }
}
